@if (selectedTowerData$ | async; as data) {
  <div class="cdr-modal-backdrop" (click)="close()">
    <div class="cdr-modal-card" (click)="$event.stopPropagation()">
      <!-- Modal Header -->
      <div class="modal-header">
        <div class="header-left">
          <div class="tower-icon-badge">
            <i class="fa-solid fa-tower-cell"></i>
          </div>
          <div class="header-meta">
            <div class="meta-sub">
              <span class="region-badge">{{ data.tower.region }}</span>
              <span class="status-badge" [class.operational]="data.tower.site_status === 'Operational'" [class.maintenance]="data.tower.site_status !== 'Operational'">
                {{ data.tower.site_status }}
              </span>
            </div>
            <h3 class="tower-title">{{ data.tower.cell_id }}</h3>
          </div>
        </div>

        <div class="header-right">
          <button class="action-btn fly-btn" (click)="flyToCity(data.tower.region)" title="Focus View">
            <i class="fa-solid fa-crosshairs"></i>
          </button>
          <button class="action-btn close-btn" (click)="close()" title="Close">
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>
      </div>

      <!-- Modal Body -->
      <div class="modal-body">
        <!-- Tower Specs Grid -->
        <div class="specs-grid">
          <div class="spec-card">
            <span class="spec-label">Site ID</span>
            <span class="spec-val">{{ data.tower.site_id }}</span>
          </div>
          <div class="spec-card">
            <span class="spec-label">Sector</span>
            <span class="spec-val">{{ data.tower.sector }}</span>
          </div>
          <div class="spec-card">
            <span class="spec-label">Supported RAT</span>
            <span class="spec-val tag-rat">{{ data.tower.supported_rat }}</span>
          </div>
          <div class="spec-card">
            <span class="spec-label">LAC / TAC</span>
            <span class="spec-val font-mono">{{ data.tower.lac }} / {{ data.tower.tac }}</span>
          </div>
          <div class="spec-card full-span">
            <span class="spec-label">Coordinates (Lat, Lon)</span>
            <span class="spec-val font-mono text-cyan">{{ data.tower.latitude | number:'1.6-6' }}, {{ data.tower.longitude | number:'1.6-6' }}</span>
          </div>
        </div>

        <!-- CDR Activity Metrics -->
        <div class="section-title">
          <i class="fa-solid fa-chart-pie"></i>
          <span>Synthetic CDR Activity Metrics</span>
        </div>

        <div class="stats-grid">
          <div class="stat-card">
            <span class="stat-icon-wrap icon-cyan">
              <i class="fa-solid fa-list-check"></i>
            </span>
            <div class="stat-info">
              <span class="stat-num">{{ data.stats.totalEvents }}</span>
              <span class="stat-lbl">Total CDR Events</span>
            </div>
          </div>

          <div class="stat-card">
            <span class="stat-icon-wrap icon-lime">
              <i class="fa-solid fa-phone"></i>
            </span>
            <div class="stat-info">
              <span class="stat-num">{{ data.stats.voiceCount }}</span>
              <span class="stat-lbl">Voice Calls ({{ (data.stats.totalDurationSec / 60) | number:'1.1-1' }} mins)</span>
            </div>
          </div>

          <div class="stat-card">
            <span class="stat-icon-wrap icon-amber">
              <i class="fa-solid fa-comment-dots"></i>
            </span>
            <div class="stat-info">
              <span class="stat-num">{{ data.stats.smsCount }}</span>
              <span class="stat-lbl">SMS Messages</span>
            </div>
          </div>

          <div class="stat-card">
            <span class="stat-icon-wrap icon-magenta">
              <i class="fa-solid fa-wifi"></i>
            </span>
            <div class="stat-info">
              <span class="stat-num">{{ data.stats.totalMB | number:'1.1-2' }} MB</span>
              <span class="stat-lbl">Data ({{ data.stats.dataCount }} sessions)</span>
            </div>
          </div>
        </div>

        <!-- Recent CDR Activity Logs Table -->
        @if (data.recentCdrs && data.recentCdrs.length > 0) {
          <div class="section-title">
            <i class="fa-solid fa-clock-rotate-left"></i>
            <span>Recent CDR Transactions ({{ data.recentCdrs.length }})</span>
          </div>

          <div class="table-container">
            <table class="cdr-table">
              <thead>
                <tr>
                  <th>Event Type</th>
                  <th>Subscriber</th>
                  <th>Timestamp</th>
                  <th>Status</th>
                  <th>Details</th>
                </tr>
              </thead>
              <tbody>
                @for (cdr of data.recentCdrs | slice:0:8; track cdr.cdr_id) {
                  <tr>
                    <td>
                      <span class="event-tag" [class.voice]="cdr.event_type.startsWith('VOICE')" [class.sms]="cdr.event_type.startsWith('SMS')" [class.data]="cdr.event_type.startsWith('DATA')">
                        {{ cdr.event_type }}
                      </span>
                    </td>
                    <td class="font-mono">{{ cdr.subscriber_id }}</td>
                    <td class="text-subtle">{{ cdr.event_start }}</td>
                    <td>
                      <span class="status-dot-tag" [class.success]="cdr.event_status === 'COMPLETED' || cdr.event_status === 'DELIVERED'">
                        {{ cdr.event_status }}
                      </span>
                    </td>
                    <td class="font-mono">
                      @if (cdr.event_type.startsWith('DATA')) {
                        {{ cdr.total_mb | number:'1.2-2' }} MB
                      } @else if (cdr.event_type.startsWith('VOICE')) {
                        {{ cdr.duration_sec }}s
                      } @else {
                        SMS
                      }
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        }
      </div>
    </div>
  </div>
}
